import { RaceInfoSkeleton } from 'modules/race/components/RaceInfoSkeleton';
import React from 'react';
import styled from 'styled-components';

import { PageContent } from 'src/styledComponents/PageContent';
import { Skeleton } from 'src/styledComponents/Skeleton';
import { RESOLUTIONS } from 'src/constants';
import DelayedLoader from 'src/components/DelayedLoader';
import { t } from 'utils';

const SHOW_DELAYED_LOADER_AFTER_MS = 3000;

const SkeletonWrapper = styled.div`
  @media (max-width: ${RESOLUTIONS.medium}px) {
    > section:first-child {
      padding-top: 32px;
    }
  }
`;

const NavigationSkeleton = styled(PageContent)`
  background: ${(props) => props.theme.main.colors.white};

  .section-content {
    > div {
      display: flex;
      align-items: center;
      margin: 0 auto;
      padding: 16px 0;

      > div:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
`;

const RaceDetailsContainerSkeleton = () => {
  return (
    <SkeletonWrapper>
      <DelayedLoader 
        delay={SHOW_DELAYED_LOADER_AFTER_MS}
        translations={{
          title: t.staticAsString('race.loader.title'),
          message: t.staticAsString('race.loader.message'),
          cta: t.staticAsString('race.loader.cta')
        }}
      />
      <RaceInfoSkeleton />
      <NavigationSkeleton>
        <div>
          <Skeleton width={65} height={20} variant='text' />
          <Skeleton width={94} height={20} variant='text' />
          <Skeleton width={30} height={20} variant='text' />
          <Skeleton width={75} height={20} variant='text' />
          <Skeleton width={60} height={20} variant='text' />
        </div>
      </NavigationSkeleton>
    </SkeletonWrapper>
  );
};

export default RaceDetailsContainerSkeleton;
